// =====================================
//
//   login Modal
//   Author: Gray
//   createtime: 2016 / 09 / 02
//
// =====================================

window.InifECMobileApp.directive('login', ['$rootScope', '$ngModal', '$timeout', 'UserService', 'FacebookService', '$state', '$InifECGA',
    function ($rootScope, $ngModal, $timeout, UserService, FacebookService, $state, $InifECGA) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            var loginWithEmail = function() {

                if($scope.isLoginWithEmail){
                    return;
                }

                resetLoginState();

                if(!$scope.form.email || !isEmail($scope.form.email)){
                    $scope.isEmailError = true;
                }

                if(!$scope.form.password){
                    $scope.isPasswordError = true;
                }

                if($scope.isEmailError || $scope.isPasswordError) {
                    return;
                }

                $scope.isLoginWithEmail = true;
                $scope.passwordFailed = false;
                $scope.isMemberFreeze = false;
                $scope.emailUnverified = false;
                $scope.accountNotExist = false;
                $scope.loginTypeError = false;
                $scope.isSystemError = false;

                UserService.loginWithEmail($scope.form.email, $scope.form.password).then(function(result){
                    
                    $timeout(function(){
                        closeModal();
                        // 延遲在結束比較不會造成視覺閃動
                        $scope.form.email = undefined;
                        $scope.form.password = undefined;
                        $scope.isLoginWithEmail = false;
                        $rootScope.$broadcast("LOGIN_SUCCESS");
                        if($scope.callback) {
                            $scope.callback();
                        } else {
                            $rootScope.$broadcast('OPEN_LOADING_SUCCESS_MODAL', {
                                title: '登入成功',
                            });
                        }

                        const mrscid = UserService.user.mrscid;
                        $InifECGA.eventTrack('member', 'login', mrscid);
                        $InifECGA.eventTrack('member', 'email_login', mrscid);
                    }, 500);
                }, function(error){
                    $scope.isLoginWithEmail = false;

                    if(error && error.code === 'error.formValidator.passwordFailed'){
                        $scope.passwordFailed = true;
                    }else if(error && error.code === 'error.account.isFreeze'){
                        $scope.isMemberFreeze = true;
                    }else if(error && error.code === 'error.emailUnverified'){
                        $scope.emailUnverified = true;
                    }else if(error && error.code === 'error.account.accountNotExist'){
                        $scope.accountNotExist = true;
                    }else if(error && error.code === 'error.loginTypeError'){
                        $scope.loginTypeError = true;
                    }else{
                        $scope.isSystemError = true;
                    }
                });
            }

            var loginWithFacebook = function() {

                if($rootScope.useNativeLoginModal) {
                    // window.location.href = "/nativeLogin/fblogin?url=" + $state.href($scope.backToState?$scope.backToState:$state.current.name, {}, {absolute: true});
                    $state.go(window.STATES.NATIVE_LOGIN_MODAL, 
                        {
                            state: 'fblogin', 
                            backstate: $scope.backToState?$scope.backToState:$state.current.name
                        }
                    ); 
                } else {

                    if($scope.isLoginWithFacebook){
                        return;
                    }

                    resetLoginState();
                    
                    $scope.isLoginWithFacebook = true;
                    FacebookService.loginWithFacebook(false).then(function(result){
                       
                        $timeout(function(){
                            closeModal();
                            $scope.isLoginWithFacebook = false;
                            // $rootScope.$broadcast("LOGIN_SUCCESS");
                            // if($scope.callback) {
                            //     $scope.callback();
                            // } else {
                            //     $rootScope.$broadcast('OPEN_LOADING_SUCCESS_MODAL', {
                            //         title: '登入成功',
                            //     });
                            // }

                            const mrscid = UserService.user.mrscid;
                            $InifECGA.eventTrack('member', 'login', mrscid);
                            $InifECGA.eventTrack('member', 'fb_login', mrscid);
                        },500);
                    }, function(error) {
                        $scope.isLoginWithFacebook = false;
                        $scope.fbLoginErrorMsg = error.message;
                    });
                }
            }

            var openFacebookForgotPasswordModal = function () {
                
                $rootScope.$broadcast("OPEN_FORGOT_PASSWORD_MODAL");

                closeModal();
            }

            var openFacebookDisableModal = function(){
                $rootScope.$broadcast("OPEN_CONFIRM_MODAL", {
                    confirmLabel:"設定您的密碼",
                    hideCancel: false,
                    title: "請使用您的Facebook的Email登入",
                    description: "<div style = 'text-align: left !important'>很抱歉，Facebook登入暫時有點問題<br>* 請點擊「確定」<br>* 輸入您Facebook帳號使用的Email系統將會寄送密碼重置信到您的信箱<br>非常抱歉造成您的不便敬請見諒<div>",
                    callback: function(result) {
                        if(result){
                            openFacebookForgotPasswordModal();
                        }
                    }
                });
            }

            var register = function() {

                $rootScope.$broadcast("OPEN_REGISTER_MODAL");
            }

            var openModal = function(backToState) {

                resetLoginState();

                // if($rootScope.useNativeLoginModal){
                //     // 得目前state的完整url
                //     window.location.href = "/nativeLogin/fblogin?url=" + $state.href(backToState?backToState:$state.current.name, {}, {absolute: true});
                // } else {
                    
                // }

                $ngModal.openModal('login-modal');    
            }

            var closeModal = function() {
                $ngModal.closeModal('login-modal');
            }

            var resetLoginState = function() {

                // 登入用的 whih email
                $scope.isLoginWithEmail = false;
                $scope.isEmailError = false;
                $scope.isPasswordError = false;
                $scope.passwordFailed = false;
                $scope.isSystemError = false;
                $scope.isMemberFreeze = false;
                $scope.emailUnverified = false;
                $scope.accountNotExist = false;
                $scope.loginTypeError = false;
                // 登入用的 whih facebook
                $scope.isLoginWithFacebook = false;
                $scope.facebookLoginError = false;
                $scope.isFbMemberFreeze = false;
                $scope.isConnectFacebookError = false;
            }

            var init = function() {

            }

            /*==========================
                Events
            ==========================*/

            $scope.$on("OPEN_LOGIN_MODAL", function(event, data) {

                $scope.backToState = undefined;
                $scope.callback = undefined;

                if(data){
                    $scope.backToState = data.backToState;
                    $scope.callback = data.callback;
                    openModal(data.backToState);    
                } else {
                    openModal(false);
                }
            });

            /*==========================
                Members
            ==========================*/

            $scope.form = {
                email: '',
                password: ''
            };
            

            // 登入用的 whih email
            $scope.isLoginWithEmail = false;
            $scope.isEmailError = false;
            $scope.isPasswordError = false;
            $scope.passwordFailed = false;
            $scope.isSystemError = false;
            $scope.isMemberFreeze = false;
            $scope.emailUnverified = false;
            $scope.accountNotExist = false;
            $scope.loginTypeError = false;
            // 登入用的 whih facebook
            $scope.isLoginWithFacebook = false;
            $scope.facebookLoginError = false;
            $scope.isFbMemberFreeze = false;
            $scope.isConnectFacebookError = false;

            /*==========================
                Methods
            ==========================*/

            $scope.loginWithEmail = loginWithEmail;
            $scope.loginWithFacebook = loginWithFacebook;
            $scope.openFacebookDisableModal = openFacebookDisableModal;
            $scope.register = register;
            $scope.callback;
            
            /*==========================
                init
            ==========================*/

            init();
        }]

        _dir.restrict = "E";
        _dir.scope = true;
        _dir.templateUrl = "mobile/partials/modal/login.html";
        _dir.controller = controller;

        return _dir;
    }]
);